<template>
  <div class="user-wrap" style="display: block;">
    <div >
      <van-nav-bar
  title=""
  left-text="返回主页"
  left-arrow
  @click-left="onClickLeft"
/>
    </div>
    <div v-for="ele in menuData.filter(val=>val.ifShow)" :key="ele.id" class="ul-wrapper">
      <div class="information">
        <a href="/">{{ele.text}}</a>
      </div>
      <ul class="subclass-ul">
        <li :name="i.id" :to="{name:i.to}" v-for="i in ele.children.filter(val=>val.ifShow)" :key="i.id">
          <a :href="'/'+i.to" class="transition" >{{i.text}}</a>
        </li>
      </ul>
    </div>
    <div class="vip-nav-content">
      <div class="title">
        <a href="/accountCenter">
          个人中心
          <div class="pull-right time">
            <i class="icon icon-right"></i>
          </div>
        </a>
      </div>
    </div>
    <div class="user-face-wrap" v-if="!logined">
      <div class="text-center">
        <a class="login-link c3 border-1px" href="/login">登录</a>
        <a class="login-link b1 border-1px" href="/register">注册</a>
      </div>
    </div>
    <!--<div class="user-face-wrap" v-if="logined">
      <div class="text-center"> 
        <a class="login-link b1 border-1px" @click="logout">退出登录</a>
      </div>
    </div>-->
  </div>
</template>
<script>
let authority = [];
let authData = JSON.parse(localStorage.getItem("authData"));
if (authData) {
  authority = authData.barRights;
}
export default {
  name: "menuBar",
  data() {
    return {
      logined: false,
      defaultMenuData: [
        /*{
          id: "0",
          text: "样品检测",
          ifShow: true,
          icon: "ios-flask",
          children: [
            { text: "接收样品", id: "0-1", to: "projectReceive", ifShow: true },
            { text: "录入数据", id: "0-2", to: "inspectionWork", ifShow: true }
          ]
        },
        {
          id: "1",
          text: "报告相关",
          ifShow: true,
          icon: "ios-paper",
          children: [
            { text: "报告查询", id: "1-1", to: "wreportQuery", ifShow: true },
            { text: "报告编辑", id: "1-2", to: "reportEditS", ifShow: true },
            { text: "报告审核", id: "1-3", to: "reportVerify", ifShow: true },
            { text: "报告批准", id: "1-4", to: "reportApprove", ifShow: true },
            { text: "报告打印", id: "1-5", to: "reportPrint", ifShow: true }
          ]
        },*/
        // {
        //   id: "2",
        //   text: "业务管理",
        //   ifShow: true,
        //   icon: "md-analytics",
        //   children: [
        //     { text: "新建委托", id: "2-1", to: "orderWork", ifShow: true },
        //     { text: "委托管理", id: "2-2", to: "orderManage", ifShow: true },
        //     { text: "客户管理", id: "2-3", to: "customerManage", ifShow: true },
        //     { text: "产品管理", id: "2-4", to: "productManage", ifShow: true },
        //     { text: "样品管理", id: "2-5", to: "sampleManage", ifShow: true },
        //     { text: "收件管理", id: "2-6", to: "packageManage", ifShow: true },
        //     /*{ text: "快递发货", id: "2-10", to: "deliveryManage", ifShow: true }*/
        //   ]
        // },
        {
          id: "3",
          text: "资料档案",
          ifShow: true,
          icon: "ios-stats",
          children: [
            { text: "标准查询", id: "3-1", to: "standard_l", ifShow: true },
            /*{
              text: "标准数据维护",
              id: "3-2",
              to: "standardManage",
              ifShow: true
            },*/
            { text: "失效案例查询", id: "3-3", to: "ra_l", ifShow: true },
            /*{
              text: "失效案例数据维护",
              id: "3-4",
              to: "raManage",
              ifShow: true
            },*/
            { text: "材料查询", id: "3-5", to: "mat_l", ifShow: true },
            /*{ text: "材料数据维护", id: "3-6", to: "matManage", ifShow: true }*/
          ]
        },
        {
          id: "4",
          text: "实验室管理",
          ifShow: true,
          icon: "ios-people",
          children: [
            {
              text: "统计数据",
              id: "4-1",
              to: "dataPanel",
              ifShow: true,
            },
            {
              text: "铁道工程",
              id: "4-2",
              to: "railway",
              ifShow: true,
            },
            /*{
              text: "人员权限管理",
              id: "4-2",
              to: "staffManage",
              ifShow: true
            },
            {
              text: "设备管理",
              id: "4-3",
              to: "equipmentManage",
              ifShow: true
            },
            {
              text: "检测数据记录管理",
              id: "4-4",
              to: "recordManage",
              ifShow: true
            }*/
          ]
        },
        /*{
          id: "4",
          text: "实验室管理",
          ifShow: true,
          icon: "ios-people",
          children: [
            {
              text: "统计数据大厅",
              id: "4-1",
              to: "dataPanel",
              ifShow: true
            },
            {
              text: "人员权限管理",
              id: "4-2",
              to: "staffManage",
              ifShow: true
            },
            {
              text: "设备管理",
              id: "4-3",
              to: "equipmentManage",
              ifShow: true
            },
            {
              text: "检测数据记录管理",
              id: "4-4",
              to: "recordManage",
              ifShow: true
            }
          ]
        },
        {
          id: "5",
          text: "综合服务",
          ifShow: true,
          icon: "ios-cafe",
          children: [
            { text: "寄快递", id: "5-1", to: "personalDelivery", ifShow: true }
          ]
        },
        {
          id: "6",
          text: "财务相关",
          ifShow: true,
          icon: "logo-yen",
          children: [
            { text: "收款登记", id: "6-1", to: "cashCheck", ifShow: true },
            { text: "收款记录", id: "6-2", to: "cashRecord", ifShow: true }
          ]
        }*/
      ]
    };
  },
  props: {},
  methods: {
    logout: function () {
          localStorage.clear();
          this.logined = false;
          location.href = "/login";
      },
      onClickLeft(){
        location.href="/index";
      }
  },
  created() {
            let userToken = localStorage.getItem("current_user_token");
            if (userToken) {
                this.logined = true;
            }
        },
  computed: {
    menuData: function() {
      let newData = JSON.parse(JSON.stringify(this.defaultMenuData));
      if (authority.indexOf("super_all") !== -1) {
        return newData;
      } else if (authority.length === 0) {
        return [];
      } else {
        for (let i = 0; i < this.defaultMenuData.length; i++) {
          for (let j = 0; j < this.defaultMenuData[i].children.length; j++) {
            if (
              authority.indexOf(this.defaultMenuData[i].children[j].to) === -1
            ) {
              newData[i].children[j].ifShow = false;
            } else {
              newData[i].children[j].ifShow = true;
            }
          }
          if (
            newData[i].children.every(ele => {
              return !ele.ifShow;
            })
          ) {
            newData[i].ifShow = false;
          } else {
            newData[i].ifShow = true;
          }
        }
        return newData;
      }
    }
  }
};
</script>
<style scoped>
.user-wrap {
  position: absolute;
  background: #fff;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 100%;
  margin-top: 0px;
  overflow: auto;
  padding-bottom: 105px;
}

.user-wrap .information {
  font-size: 0.8rem;
  padding: 1.125rem 1.125rem 0.5rem 1.125rem;
}

a {
  color: #303030;
  cursor: pointer;
  text-decoration: none;
}

.ul-wrapper{
    border-bottom: 1px solid #f0f0f0;
}

.subclass-ul {
  display: inline-block;
  width: 100%;
  padding: 0 0.5rem 0.75rem 1.35rem;
  box-sizing: border-box;
  color: #666;
  font-size: 0.6rem;
  vertical-align: top;
  display: flex;
  display: -webkit-flex;
  flex-flow:row wrap;
  justify-content:flex-start;
}

.subclass-ul li {
  width: 33.3%;
  height: 1.5rem;
  line-height: 1.5rem;
  text-align: left;
  overflow: hidden;
}

ol li,
ul li {
  list-style: none;
}

.subclass-ul li a {
  color: #666;
}

.user-face-wrap {
  position: relative;
  padding: 1rem 0 2rem;
}

.text-center {
  text-align: center;
}

.login-link {
  display: inline-block;
  width: 7.5rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 0.85rem;
  margin-top: 0.25rem;
  border-radius: 0.15rem;
}

.login-link:nth-child(2) {
  margin-left: 1rem;
  color: #fff;
}

.border-1px {
  position: relative;
}

.border-1px:before {
  content: "";
  pointer-events: none;
  box-sizing: border-box;
  position: absolute;
  width: 200%;
  height: 200%;
  left: 0;
  top: 0;
  border-radius: 0.4rem;
  border: 1px solid #ff6060;
  -webkit-transform: scale(0.5);
  -webkit-transform-origin: 0 0;
  transform: scale(0.5);
  transform-origin: 0 0;
}

.b1,
.bg-f60 {
  background: #ff6060;
}

.vip-nav-content {
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  padding: 1rem 1.25rem 1rem 1.25rem;
  margin-top:3rem;  
}

.vip-nav-content .title {
  position: relative;
  font-size: 0.8rem;
}

.vip-nav-content .title a {
  display: inline-block;
  width: 100%;
}

a {
  color: #303030;
  cursor: pointer;
  text-decoration: none;
}

.vip-nav-content .title .time {
  font-size: 0.65rem;
  color: #bbb;
  margin-top: 0.1rem;
}

.pull-right {
  float: right;
}

.icon-right {
  right: 0;
  background-position: -165px -206px;
}

.icon {
  display: inline-block;
  vertical-align: text-bottom;
  background: url(../assets/icon.png) no-repeat;
  width: 15px;
  height: 16px;
  cursor: pointer;
  background-size: 250px 300px;
}

.icon-right {
    right: 0;
    background-position: -165px -206px;
}

em,
i {
  font-style: normal;
}
</style>